import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-16 bg-brand-bg border-y border-brand-primary/10" data-id="element-62">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-63">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex flex-col md:flex-row items-center gap-8 bg-white p-8 md:p-10 rounded-3xl shadow-sm" data-id="element-64">
          <div className="flex-shrink-0" data-id="element-65">
            <div className="w-24 h-24 bg-brand-primary/10 rounded-full flex items-center justify-center" data-id="element-66">
              <ShieldCheck className="w-12 h-12 text-brand-primary" data-id="element-67" />
            </div>
          </div>
          <div className="text-center md:text-left" data-id="element-68">
            <h2 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-69">
              Garantía de Devolución de 60 Días
            </h2>
            <p className="text-gray-600 leading-relaxed" data-id="element-70">
              Estamos tan seguros de que este recetario transformará tu salud,
              que te ofrecemos una garantía incondicional. Si en los próximos 60
              días no estás satisfecho con las recetas o los resultados, te
              devolvemos el 100% de tu dinero. Sin preguntas, sin
              complicaciones.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}